<template>
  <form class="form" method="post">

    <div>
      <HeaderApp />
      <div id="appPublicationVueComponent" class="appFontBlack">
        <div class="titleAppName">
          <h2>Publications Web</h2>
          <div>
            <button @click.prevent="createPublication()" type="submit" class="appButtonModel2">Ajouter une
              publication</button>
          </div>
        </div>
        <br>

        <div :key="index" v-for="(article, index) in article" class="appPublicationCardList">
          <div @click.prevent="editPublication(article._id)" type="submit">
            <div class="appPublicationCardListLine1">
              <p>{{ article.title }}</p>
              <p>{{ article.date }}</p>
            </div>
            <div class="appPublicationCardListLine2">
              <img class="appPublicationImages" v-bind:src=article.imageUrl>
              <p>{{ article.description }}</p>
            </div>
            <div class="appPublicationCardListLine3">
            </div>
          </div>
        </div>

      </div>
    </div>

</form></template>

<script>
import axios from 'axios'
import moment from 'moment'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'PublicationsList',
  data () {
    return {
      article: ''
    }
  },
  mounted () {
    this.getAllPublications()
  },
  methods: {
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    getAllPublications () {
      const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
      axios
        .get(('https://privilegia.fr/api/articles'), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
        .then((response) => {
          this.article = response.data.reverse()
        })
    },
    createPublication () {
      this.$router.push('/App/Publications/Create')
    },
    editPublication (id) {
      this.$router.push('/App/Publications/Edit?id=' + id)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppPublicationsChoice.vue